import { CORAL, INK, MINT, lerpColor } from '../../color';
import { BOIL_AMP } from '../../ink';
import type { WorldDress, WorldFx } from '../../world';

const TICKS = 24;

export const dress: WorldDress = {
  incomingCircle(k, body, color, alpha) {
    const r = body.radius;
    k.hatch(body, Math.PI / 4, Math.max(2.4, r * 0.13), 0.26, lerpColor(color, INK, 0.55), 0.42 * alpha, 1.1);
    k.highlight(body, 0.75 * alpha);
  },

  mineCircle(k, body, alpha, width, fill, seed) {
    const { g, pal } = k;
    const r = body.radius;
    k.trace(body);
    g.fill({ color: fill, alpha });
    k.hatch(body, Math.PI / 4, Math.max(2.4, r * 0.12), 0.24, lerpColor(fill, CORAL, 0.6), 0.5 * alpha, 1.2);
    k.highlight(body, 0.8 * alpha);
    k.inkRing(body, width, seed, k.reduced ? 0 : BOIL_AMP, pal.ink, alpha);
  },

  target(k, body, alpha, spread, reach, spin, edge) {
    const { g } = k;
    const r = body.radius;
    k.trace(body);
    g.fill({ color: INK, alpha: 0.07 * alpha });
    if (body.shape === 'circle') k.hatch(body, -Math.PI / 4, Math.max(3, r * 0.1), 0, INK, 0.16 * alpha, 1);
    k.trace(body, 0, 0, 1 + spread + 0.05);
    g.stroke({ width: 1, color: INK, alpha: 0.28 * alpha });
    k.ringDots(body, reach, TICKS, spin * 0.25, (x, y, i, a) => {
      const len = (i % 6 === 0 ? 0.05 : 0.025) * k.unit;
      g.moveTo(x, y).lineTo(x + Math.cos(a) * len, y + Math.sin(a) * len);
    });
    g.stroke({ width: 1.2, color: INK, alpha: 0.4 * alpha, cap: 'round' });
    k.trace(body);
    g.stroke({ width: edge, color: INK, alpha: 0.6 * alpha, join: 'round' });
  },

  pip(k, x, y, radius, on, last, alpha, width) {
    const { g } = k;
    if (last) g.star(x, y, 5, radius * 1.45, radius * 0.7, 0);
    else g.circle(x, y, radius);
    if (on) g.fill({ color: last ? MINT : INK, alpha });
    g.stroke({ width, color: INK, alpha });
  },

  path(k, points, count, alpha) {
    const { g, pal } = k;
    for (const off of [-1.2, 1.2]) {
      g.moveTo(points[0]! + off, points[1]! - off);
      for (let i = 2; i < count; i += 2) g.lineTo(points[i]! + off, points[i + 1]! - off);
    }
    g.stroke({ width: 1.4, color: pal.path, alpha: alpha * 2.4, cap: 'round', join: 'round' });
  },
};

export const fx: WorldFx = {
  bit(g, x, y, size, i, color, alpha, rot) {
    if (i % 3 === 0) g.circle(x, y, size * 0.5);
    else g.regularPoly(x, y, size, 4, rot);
    g.fill({ color: i % 3 === 0 ? INK : color, alpha });
  },

  milestone(g, m) {
    g.circle(m.x, m.y, m.r).stroke({ width: m.width, color: INK, alpha: m.fade * 0.55 });
    g.circle(m.x, m.y, m.r * 1.18).stroke({ width: m.width * 0.6, color: MINT, alpha: m.fade * 0.45 });
  },

  trail(g, x, y, size, angle) {
    g.star(x, y, 5, size, size * 0.45, angle);
  },
};
